module.exports = __webpack_public_path__ + "static/media/accessories4.4a1cc294.jpg";